<dialog
  (close)="close()"
  [class.modal]="config.modal"
  [class.backdrop]="config.backdrop"
  [pluginsVerticalOffset]="config.verticalOffset"
  [pluginsVerticalOffsetDisabled]="config.verticalOffsetDisabled"
  #dialog
>
  <ng-template #vcr />
</dialog>
